// ============================================================================
// COERÊNCIA PRODUTO × OPERADORA (Douglas 07/08/2026)
//
// A régua que faltava e deixou um PN com linha CLARO fechar pedido (2608060062):
//   PORTABILIDADE (PN NOVO)  → a linha precisa ser de OUTRA operadora
//   TT / RENOVAÇÃO / MP      → a linha precisa ser CLARO
//
// Só bloqueia com operadora CONFIRMADA pela consulta. Sem consulta (cache vazio,
// API fora) NÃO bloqueia — venda não pode travar porque a API caiu; o selo fica
// "não verificado" e a validação de fechamento pega depois.
// ============================================================================

export type RegraOperadora = 'EXIGE_CLARO' | 'EXIGE_NAO_CLARO';

export const isClaro = (operadora: string | null | undefined): boolean =>
  !!operadora && operadora.toUpperCase().includes('CLARO');

/** Normaliza para o formato do cache `telefones_operadora` (55 + DDD + número). */
export function to55(raw: string | null | undefined): string | null {
  const d = String(raw ?? '').replace(/\D/g, '');
  if (d.length === 10 || d.length === 11) return `55${d}`;
  if ((d.length === 12 || d.length === 13) && d.startsWith('55')) return d;
  return null;
}

/**
 * Régua pelo TIPO da linha do Montador (composição da proposta).
 * Tipos sem linha existente (incremento/alta nova) não têm o que conferir.
 */
export function regraPorTipoLinha(tipo: string | null | undefined): RegraOperadora | null {
  const t = String(tipo ?? '').toUpperCase();
  if (t === 'PORTABILIDADE') return 'EXIGE_NAO_CLARO';
  if (t === 'TT' || t === 'RENOVACAO' || t === 'RENOVAÇÃO' || t === 'MP') return 'EXIGE_CLARO';
  return null;
}

/**
 * Régua pelo NOME do produto do pedido (validação de fechamento).
 * ⚠️ TT FIXA fica fora (linha fixa); PN INCREMENTO fica fora (linha nova, não
 * há número a conferir — se houver número digitado, é o número novo da Claro).
 */
export function regraPorProduto(produtoNome: string | null | undefined): RegraOperadora | null {
  const n = String(produtoNome ?? '').toUpperCase().trim();
  if (n === 'PN NOVO') return 'EXIGE_NAO_CLARO';
  if (n === 'RENOVAÇAO' || n === 'RENOVAÇÃO') return 'EXIGE_CLARO';
  if (n.startsWith('MP MÓVEL') || n.startsWith('MP MOVEL')) return 'EXIGE_CLARO';
  if (n.startsWith('TT ') && !n.includes('FIXA')) return 'EXIGE_CLARO';
  return null;
}

/** Mensagem de conflito, ou null quando está coerente / sem régua / sem operadora. */
export function conflitoOperadora(
  regra: RegraOperadora | null,
  operadora: string | null | undefined,
): string | null {
  if (!regra || !operadora) return null;
  if (regra === 'EXIGE_NAO_CLARO' && isClaro(operadora)) {
    return `linha já é ${operadora} — não há o que portar; use TT ou Renovação`;
  }
  if (regra === 'EXIGE_CLARO' && !isClaro(operadora)) {
    return `linha é ${operadora} — TT/Renovação exigem linha CLARO; use Portabilidade`;
  }
  return null;
}
